import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileboxOperationEnum } from '../enums/filebox-operation.enum';
import { FileboxStatusEnum } from '../enums/filebox-status.enum';

/**
 * Filebox DTO for records
 */
@CaslSubject(AppSubjectEnum.FILEBOX)
export class FileboxRecordDto extends BaseDto {
	/**
	 * Tenant ID
	 */
	tenantId!: number;

	/**
	 * Recipient user ID
	 */
	userId!: number;

	/**
	 * Status of the record
	 */
	status!: FileboxStatusEnum;

	/**
	 * Operation to be performed on the filebox item
	 */
	operation!: FileboxOperationEnum;

	/**
	 * Composite key describing the event and action that triggered the synchronization
	 */
	key!: string;

	/**
	 * File UUID
	 */
	fileUuid!: string;

	/**
	 * Unique token for the item synchronization process
	 */
	synchronizationToken!: string;

	/**
	 * Number of times the item has been retried
	 */
	retryCount!: number;

	/**
	 * Timestamp for the next retry attempt
	 */
	nextRetryAt?: Date;

	/**
	 * The worker ID that reserved the message
	 */
	leasedBy?: string;

	/**
	 * Timestamp until when the item is reserved
	 */
	leasedUntil?: Date;

	/**
	 * Timestamp for when the item was synchronized
	 */
	synchronizedAt?: Date;

	/**
	 * Error message if the item failed to synchronize
	 */
	synchronizationError?: string;
}
